<template>
<div>
    <Box  @close="cerrar()">
        <template #top>Historial de Transferencias</template>
        <template #center>
            <b-table :data="historial" :paginated="isPaginated" :per-page="perPage" :current-page.sync="currentPage" :pagination-simple="isPaginationSimple" :pagination-position="paginationPosition"
                :default-sort-direction="defaultSortDirection" :pagination-rounded="isPaginationRounded" :sort-icon="sortIcon" :sort-icon-size="sortIconSize" aria-next-label="Next page"
                aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page">
                <template slot-scope="props">
                    <b-table-column label="Producto" header-class="is-info">{{ props.row.prv_nombre }}</b-table-column>
                    <b-table-column label="Fecha registro" header-class="is-info">{{ props.row.tfi_fecha_registro }}</b-table-column>
                    <b-table-column label="Cantidad transferida" header-class="is-info" style="text-align: right;">{{ props.row.tid_cantidad }}</b-table-column>
                    <b-table-column label="Fecha ingreso" header-class="is-info">{{ props.row.tfi_fecha_ingreso }}</b-table-column>
                    <b-table-column label="Cantidad ingresada" header-class="is-info" style="text-align: right;">{{ props.row.tid_ingreso_cantidad }}</b-table-column>
                    <b-table-column label="Notas" header-class="is-info">{{ props.row.tid_ingreso_notas }}</b-table-column>
                </template>
            </b-table>
        </template>
    </Box>
</div>
</template>

<script>

import { TransferenciaItemsService } from "../../services"
import { Box } from "../components"

export default {
    name: "HistorialTransferencias",
    components: {
        Box,
    },
    props: {
        pal_id: null
    },
    data() {
        return {
            historial: [],
            isPaginated: true,
            isPaginationSimple: false,
            isPaginationRounded: false,
            paginationPosition: "bottom",
            defaultSortDirection: "asc",
            sortIcon: "arrow-up",
            sortIconSize: "is-small",
            currentPage: 1,
            perPage: 10,
        }
    },
    methods: {
        buscar() {
            TransferenciaItemsService.historialTransferenciasxItem({
                pal_id: this.pal_id
            }).then(
                response => {
                    this.historial = response.data
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        cerrar() {
            this.$emit("close")
        }
    },
    mounted() {
        this.buscar()
    }
}
</script>

<style scoped></style>